<div class="border-dialog">
  @if (!generatingInvoices) {
    <div align="center">
      <p>
        This will execute a refresh on invoices and may take some time,
        <br />
        Do you want to continue?
      </p>
      <mat-dialog-actions align="center">
        <button
          mat-raised-button
          (click)="generateUpdatedInvoices()"
          color="primary"
          >
          Confirm
        </button>
        <button mat-raised-button mat-dialog-close color="warn">
          Cancel
        </button>
      </mat-dialog-actions>
    </div>
  }
  @if (generatingInvoices) {
    <div align="center">
      <mat-progress-bar style="height: 4px; width: 100%;" mode="indeterminate"></mat-progress-bar>
    </div>
  }
</div>
